import request from '../../../util/SuperagentUtils';

export const correlationIdRequest = () => {
    return request.post('/api/check-in/correlation-id')
}
